import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = {
  key: 0,
  class: "col-12 lg:col-6 xl:col-6"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "m-0" }, " Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore sed consequuntur error repudiandae numquam deserunt quisquam repellat libero asperiores earum nam nobis, culpa ratione quam perferendis esse, cupiditate neque quas! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore sed consequuntur error repudiandae numquam deserunt quisquam repellat libero asperiores earum nam nobis, culpa ratione quam perferendis esse, cupiditate neque quas! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore sed consequuntur error repudiandae numquam deserunt quisquam repellat libero asperiores earum nam nobis, culpa ratione quam perferendis esse, cupiditate neque ", -1)
const _hoisted_4 = { class: "grid align-items-center justify-content-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg" }, "Cek Antrian", -1)
const _hoisted_6 = { class: "grid p-0" }
const _hoisted_7 = { class: "col-4 md:col-2 lg:col-3 p-0" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-8 md:col-10 lg:col-9 p-0" }, [
  /*#__PURE__*/_createTextVNode(" Saya sudah pernah daftar Online tapi lupa nomer antrian atau belum disimpan, Berapa nomor antrian saya? "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("b", null, "maka gunakan fitur cek antrian ini!!")
], -1)
const _hoisted_10 = { class: "col-12 p-0 mb-0 text-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg" }, "Pendaftaran Rawat Jalan", -1)
const _hoisted_12 = { class: "grid p-0" }
const _hoisted_13 = { class: "col-4 md:col-2 lg:col-3 p-0" }
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-8 md:col-8 lg:col-9 p-0" }, [
  /*#__PURE__*/_createTextVNode(" Saya ingin mendaftar ke layanan Rawat jalan, bagamana caranya?? "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Gunakan fitur Pendaftaran Rawat Jalan Online "),
  /*#__PURE__*/_createElementVNode("b", null, "Khusus pasien yang sudah memiliki nomor RM/nomor Pasien")
], -1)
const _hoisted_16 = { class: "col-12 p-0 mb-0 text-center" }
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = { class: "grid justify-content-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 p-0" }, null, -1)

export function render(_ctx, _cache) {
  const _component_p_card = _resolveComponent("p-card")
  const _component_p_button = _resolveComponent("p-button")
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isIklan)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_p_card, { class: "mb-0 card" }, {
            content: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.isIklan ? 'col-12 md:col-12 lg:col-6 xl:col-6' : 'col-12'])
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.isIklan ? 'col-12 md:col-12 lg:col-12 xl:col-6' : 'col-12 md:col-6 lg:col-6 xl:col-4'])
        }, [
          _createVNode(_component_p_card, { class: "mb-0 card p-0" }, {
            title: _withCtx(() => [
              _hoisted_5
            ]),
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("img", {
                    width: "60%",
                    src: require(`@/assets/g-tanya.png`),
                    alt: ""
                  }, null, 8, _hoisted_8)
                ]),
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_p_button, {
                    onClick: _cache[0] || (_cache[0] = $event => (_ctx.$router.push('/cekantrian'))),
                    severity: "success",
                    class: "font-bold w-full text-center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cek Antrian Saya ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.isIklan ? 'col-12 md:col-12 lg:col-12 xl:col-6' : 'col-12 md:col-6 lg:col-6 xl:col-4'])
        }, [
          _createVNode(_component_p_card, { class: "mb-0 card p-0" }, {
            title: _withCtx(() => [
              _hoisted_11
            ]),
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("img", {
                    width: "60%",
                    src: require(`@/assets/g-daftar.png`),
                    alt: ""
                  }, null, 8, _hoisted_14)
                ]),
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_p_button, {
                    onClick: _cache[1] || (_cache[1] = $event => (_ctx.$router.push('/daftar'))),
                    severity: "success",
                    class: "font-bold w-full text-center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Daftar Sekarang ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ], 2)
      ])
    ], 2),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.app_base_data.sosmed, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "col-2 md:col-2 lg:col-3 xl:col-2"
          }, [
            _createVNode(_component_p_button, {
              severity: "success",
              text: "",
              raised: "",
              rounded: "",
              "aria-label": "Cancel",
              onClick: $event => (_ctx.goToLink(item.url))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: item.icon,
                  class: _normalizeClass([item.icon_color, "text-2xl"])
                }, null, 8, ["icon", "class"])
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]))
        }), 128))
      ])
    ])
  ]))
}